import { Col, FormInstance, Row } from "antd";
import { useCallback, useState } from "react";
import { FloatNumberInput } from "../../../../components/FloatNumberInput";
import { CloseOutlined } from "@ant-design/icons";

type AccountNumberProps = {
  form: FormInstance;
};

export const AccountNumber = ({ form }: AccountNumberProps) => {
  const [isEdit, setIsEdit] = useState<boolean>(false);

  const enableEdit = useCallback(() => setIsEdit(true), []);

  const closeEdit = useCallback(() => {
    form.setFieldValue("number", "");
    setIsEdit(false);
  }, [form]);

  return (
    <Row>
      {!isEdit ? (
        <Row className="d-block">
          <p className="my-0 text-sm title w-500">
            Account number will be auto-generated.
          </p>
          <p
            className="my-0 logo-cursor text-sm ant-btn-link w-500"
            onClick={enableEdit}
          >
            Create Manually
          </p>
        </Row>
      ) : (
        <Row className="w-100 align-center">
          <Col span={22}>
            <FloatNumberInput
              name="number"
              label="Account #"
              form={form}
              className="w-100 mb-4"
              prefix=""
            />
          </Col>
          <Col span={2}>
            <CloseOutlined
              className="ml-2 logo-cursor mt-3 text-md title"
              onClick={closeEdit}
            />
          </Col>
        </Row>
      )}
    </Row>
  );
};
